module.exports = __webpack_public_path__ + "assets/help-tab.f20d3b3f.svg";